import React from "react"
import { ServerRequestProtected } from "../../../../../utils/ServerDataRequest"
import { useState, useReducer } from "react"
import { enumUtil } from "../../../../../utils/Enum"
import NotificationHandler from "../../../../../utils/NotificationHandler"
import { useEffect } from "react"
import Loader from "../../../../shared/Loader/Loader"
import Table from "../../../../Setup/Shared/Table"
import GridColumnHeader from "../../../../Setup/Shared/GridColumnHeader"
import Nav from 'react-bootstrap/Nav';
import { Modal, NavItem, NavLink } from 'reactstrap';
import { connect, useSelector } from "react-redux"
import AddNewEligibility from "./AddNewEligibility"
import SuperSearchList from "../../../../shared/SuperSearch/SuperSearchList"
import FormValidator from "../../../../../utils/FormValidator"
import isNull from "../../../../../utils/NullChecking"
import { ServiceTypeCode } from "../../../../../utils/Constants"
import DropdownValueHandler from "../../../../shared/SuperSearch/DropdownValueHandler"
import AddNewInsurance from "../../../../Setup/InsuranceM/Insurance/AddNewInsurance"
import AddNewProvider from "../../../../Setup/Account/Provider/AddNewProvider"
import HandleValidationError from "../../../../HandleValidationError/HandleValidationError"
import handleCopyText from "../../../../shared/CopyData"
import { FindFirstChild } from "../../../../../utils/FindMenuOption"
import DatePicker from "../../../../General/DatePicker"
import { format } from "date-fns"
import { GeneralDropDowns } from "../../../../../actions/GeneralPatientActions"
import { useDispatch } from "react-redux"

const Eligibility = (props) => {
    const { Settings } = { ...props }
    let IsEditAllowed = FindFirstChild('Patient', 'Eligibility')?.IsAdd
    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Eligibility = enumUtil.controller.Eligibility
    const API_URL_General = enumUtil.controller.General
    const [EligibilityID, setEligibilityID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EligibilityData, setEligibilityData] = useState([]);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    //For Pagination
    const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    // perform eligibility
    const Eligibility_Modal = {
        PatientInsuranceID: '',
        ProviderID: '',
        ServiceTypeCode: '',
        UsePracticeNPI: true,
        EligiblityDate: null
    }
    let ValModalEligibility = {}
    let ValidationModalEligibility = {
        PatientInsuranceIDval: '',
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    const [EligibilityBody, setEligibilityBody] = useState(false);
    const [mainEligibilityModal, setmainEligibilityModal] = useState(Eligibility_Modal);
    const [EligibilitySaveUpdate, setEligibilitySaveUpdate] = useState({})
    const [EligibilityValidationModal, setEligibilityValidationModal] = useState(ValidationModalEligibility)
    const [is, setIs] = useState(false);
    //
    const [EligibilityPopup, setEligibilityPopup] = useState(false);
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })

    let InsuranceList_Modal = [{
        PatientInsuranceID: "",
        CoveragePriority: "",
        InsuranceName: "",
    }]
    const [activeTab, setActiveTab] = useState()
    const [PatientInsuranceID, setPatientInsuranceID] = useState('0');
    const [InsuranceListModal, setInsuranceListModal] = useState([InsuranceList_Modal]);
    const [IsOpenInsurance, setIsOpenInsurance] = useState(false);
    const [InsuranceID, setInsuranceID] = useState(0);
    const [isOpenProvider, setIsOpenProvider] = useState(false)
    const [ProviderID, setProviderID] = useState(0);
    const [message, setMessage] = useState('')
    const [errorPopup, setErrorPopup] = useState(<></>);
    const [performClaimStatusData, setPerformClaimStatusData] = useState();

    const handleActivePlan = (ID) => {
        if (activeTab !== ID) {
            setActiveTab(ID)
        }
        setPatientInsuranceID(ID)
    }
    useEffect(() => {
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 2133) {
                    handleInsurranceDetails()

                }
            })
            if (data.length === 0) {
                handleInsurranceDetails()
            }
        }
    }, [props.Reload])
    const handleInsurranceDetails = async () => {
        if (PateintIDR != -1) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPatientInsuranceDetails", 'post', {
                "ID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.PatientInsurance
            }).then(async (response) => {
                setInsuranceListModal(response)
                setActiveTab(response[0].PatientInsuranceID)
                handleActivePlan(response[0].PatientInsuranceID)
                setIs(true)
                ServiceTypeCode.map((item) => {
                    if (item.value === '30') {
                        EligibilitySaveUpdate.ServiceTypeCode = item.value
                        mainEligibilityModal.ServiceTypeCode = item.display
                    }
                })
                EligibilitySaveUpdate.PatientInsuranceID = response[0].PatientInsuranceID + ""
                mainEligibilityModal.PatientInsuranceID = response[0].InsuranceName

                EligibilitySaveUpdate.EligiblityDate = format(new Date(), 'MM/dd/yyyy')
                mainEligibilityModal.EligiblityDate = format(new Date(), 'MM/dd/yyyy')
                ServerRequestProtected(API_URL_General + "/FindByMultipleCriteria", 'post', {
                    "TableName": enumUtil.enumAPITableName.PatientEligibility,
                    "ID": EligibilitySaveUpdate.PatientInsuranceID + "",
                    "PerPage": PerPage + "",
                    "PageNo": PageNo + "",
                }).then((response) => {
                    setIsLoading(false)
                    handleGridHeader({ defaultData: response.Rows })
                    setEligibilityData(response.Rows)
                    setTotalPages(response.count.NumOfPages);
                    setIs(true)
                    if (!isNull(response.Rows.ProviderID)) {
                        mainEligibilityModal.ProviderID = DropdownValueHandler(DropDowns?.Provider, response.Rows.ProviderID)
                        EligibilitySaveUpdate.ProviderID = response.Rows.ProviderID + ""
                    } else {
                        mainEligibilityModal.ProviderID = DropDowns?.Provider[1].display
                        EligibilitySaveUpdate.ProviderID = DropDowns?.Provider[1].value + ""
                    }
                }).catch((error) => {
                    setIsLoading(false)
                })
            })
                .catch((error) => {
                    setIsLoading(false)
                })
        }
    }
    useEffect(() => {
        setIsLoading(true)
        if (PatientInsuranceID != '0') {
            console.log(PatientInsuranceID, 'PatientInsuranceID');
            ServerRequestProtected(API_URL_General + "/FindByMultipleCriteria", 'post', {
                "TableName": enumUtil.enumAPITableName.PatientEligibility,
                "ID": PatientInsuranceID + "",
                "PerPage": PerPage + "",
                "PageNo": PageNo + "",
            }).then((response) => {
                setIsLoading(false)
                handleGridHeader({ defaultData: response.Rows })
                setEligibilityData(response.Rows)
                setTotalPages(response.count.NumOfPages);
            }).catch((error) => {
                setIsLoading(false)
                setEligibilityData([])
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
    }, [PatientInsuranceID, PerPage, PageNo, isClose])
    ////

    useEffect(() => {
        handleInsurranceDetails();
    }, [PerPage, PageNo, isClose])
    ///////////
    const LoadData = (param) => {
        setIsLoading(true)
        setEligibilityData([])
        ServerRequestProtected(API_URL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientAuthorization,
            "ID": PateintIDR + "",
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": PageNo,
        }).then((response) => {
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setEligibilityData(response.Rows)
            setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setIsLoading(false)
            // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        })
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setEnterParam(e.target.value)
            setSearchParam(EnterParam)
            LoadData(searchParam)
        }
    }

    const CloseEligibility = () => {
        setEligibilityPopup(false)
        setIsClose((Math.random()));
    }
    let PopupScreen = null;
    if (EligibilityPopup) {
        PopupScreen = <AddNewEligibility EligibilityPopup={EligibilityPopup} onClose={CloseEligibility} ID={EligibilityID} />
    }
    // console.log(PopupScreen);
    const handleOpenEligibilityPopup = (id) => {
        setEligibilityPopup(true)
        setEligibilityID(id)
    }
    const handleOpenInsurance = (id) => {
        setInsuranceID(id)
        setIsOpenInsurance(true)
    }
    const CloseInsurance = () => {
        setIsOpenInsurance(false)
    }
    const DeleteInsurance = () => {
        setIsOpenInsurance(false)
    }
    let PopupInsuranceScreen = "";
    if (IsOpenInsurance) {
        PopupInsuranceScreen = <AddNewInsurance IsOpenInsurance={IsOpenInsurance} onClose={CloseInsurance} onDeleteInsurance={DeleteInsurance} InsuranceID={InsuranceID} />
    }
    ///////////////////
    const handleOpenProvider = (id) => {
        setProviderID(id)
        setIsOpenProvider(true)
    }
    const CloseProvider = () => {
        setIsOpenProvider(false)
    }
    const DeleteProvider = () => {
        setIsOpenProvider(false)
    }
    let PopupProviderScreen = "";
    if (isOpenProvider) {
        PopupProviderScreen = <AddNewProvider isOpenProvider={isOpenProvider} onClose={CloseProvider} onDeleteProvider={DeleteProvider} ProviderID={ProviderID} />
    }
    const [copiedText, setCopiedText] = useState({});
    const handleOpenEligHistStat = (id) => {
        setEligibilityID(id)
        setEligibilityPopup(true);
    }

    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [
        {
            key: 'TransactionDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-location'} headerName={'Transaction Date'} sortIcon={true} type={'date'} colKey={'TransactionDate'} data={EligibilityData} setData={setEligibilityData} />),
            resizable: true,
            width: 130,
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100" >
                        <div className="align-items-center copy_icon copy_icon_hover tran_date d-flex gap-1 justify-content-between w-100">
                            <div className=" copy_icon validation_message" onClick={() => handleOpenEligHistStat(row.ID)}>{row.TransactionDate}</div>
                            <div className="icon_copy">
                                {row.TransactionDate && <div className="icon_copy">
                                    <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ID, row.TransactionDate)}></i>
                                    <p class="tool_tip xsm_text text-light">Copy</p>
                                </div>}
                            </div>
                            {copiedText[`${row.ID}-${row.TransactionDate}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                        {/* </div> */}
                    </button >
                );
            },
        },
        {
            key: 'Subscriber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Subscriber Name'} sortIcon={true} type={'string'} colKey={'Subscriber'} data={EligibilityData} setData={setEligibilityData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                                <div className='copy_icon'>{row.Subscriber}</div>
                                {row.Subscriber && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RecordID, row.Subscriber)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.RecordID}-${row.Subscriber}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </>
                )
            }
        },
        {
            key: 'SubscriberID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Subscriber ID'} sortIcon={true} type={'number'} colKey={'SubscriberID'} data={EligibilityData} setData={setEligibilityData} />),
        },
        {
            key: 'Payer',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Payer Name'} sortIcon={true} type={'string'} colKey={'Payer'} data={EligibilityData} setData={setEligibilityData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                                <div className='copy_icon validation_message slim_link_hover' onClick={() => handleOpenInsurance(row.InsuranceID)}>
                                    {row.Payer}
                                </div>
                                {row.InsuranceID && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RecordID, row.InsuranceID)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.RecordID}-${row.InsuranceID}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </>
                );
            }

        },
        {
            key: 'Provider',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Provider'} sortIcon={true} type={'string'} colKey={'Provider'} data={EligibilityData} setData={setEligibilityData} />),
            width: 200,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            <div className='align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100'>
                                <div className='copy_icon validation_message slim_link_hover' onClick={() => handleOpenProvider(row.ProviderID)}>
                                    {row.Provider}
                                </div>
                                {row.ProviderID && (
                                    <div className="icon_copy">
                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RecordID, row.ProviderID)} ></i>
                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                    </div>
                                )}
                                {copiedText[`${row.RecordID}-${row.ProviderID}`] ? (
                                    <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                                ) : (
                                    <></>
                                )}
                                {/* {copiedText[`${row.POSCodeID}-${row.ProviderID}`] ?<p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>:<></>} */}
                            </div>
                        </div>
                    </>
                );
            }
        },
        {
            key: 'Copay',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Copay'} sortIcon={true} type={'string'} colKey={'Copay'} data={EligibilityData} setData={setEligibilityData} />),
        },
        {
            key: 'Status',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'Status'} data={EligibilityData} setData={setEligibilityData} />),
            width: 218,
            renderCell({ row }) {
                return (
                    <>
                        {row.Status === 'Active' ? <i className='pill ar-user_active'>{row.Status}</i> :
                            row.Status === 'InActive' ? <i className='pill ar-user_active inactive-clr'>{row.Status}</i> :
                                row.Status === 'Rejected' ? <i className='pill ar-user_active Rejected-by-Payer'>{row.Status}</i> :
                                    row.Status === 'Failed' ? <div className="pill ar-user_active forward-bgc ">{row.Status}</div> : <>{row.Status}</>}
                    </>
                )
            }
        },
    ]
    const rowClass = () => { return "row-bg" }
    const handleEligibilityChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainEligibilityModal };
        let saveModal = { ...EligibilitySaveUpdate }
        if (name === "UsePracticeNPI") {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainEligibilityModal(modal)
        for (var property in Eligibility_Modal) {
            if (name === property) {
                if (name === "UsePracticeNPI") {
                    saveModal[name] = modal[name] + ""
                }
            }
        }
        setEligibilitySaveUpdate(saveModal)
    }
    const handleSaveEligibility = async () => {
        if (IsEditAllowed) {
            await EligibilityValidation()
            let validation = FormValidator([ValModalEligibility], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                EligibilitySaveUpdate['UsePracticeNPI'] = mainEligibilityModal.UsePracticeNPI + ""
                if (isNull(EligibilitySaveUpdate.ProviderID)) {
                    EligibilitySaveUpdate['ProviderID'] = '0'
                }
                let saveModal = {
                    TableName: enumUtil.enumAPITableName.Generate270,
                    data: [{ ...EligibilitySaveUpdate }],
                }
                setIsLoading(true)
                ServerRequestProtected(API_URL_Eligibility + "/EligibilityRequest", 'post', saveModal).then((response) => {
                    let msg = response.results.length != 0 ? response.results[0].validationMsg : response.errorMessage;
                    setMessage(msg);
                    setPerformClaimStatusData(response)
                    if (!isNull(response)) {
                        if (!isNull(response.errorMessage)) {
                            // NotificationHandler(response.errorMessage, enumUtil.enumtoaster.error)
                        } else {
                            setEligibilityBody(false)
                            setEligibilityPopup(true)
                            setEligibilityID(response.trnControlNumber)
                            // NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        }
                    }
                    setIsLoading(false)
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modalEligibility = { ...mainEligibilityModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'ProviderID') {
                modalEligibility[name] = selectedData.display
                EligibilitySaveUpdate[name] = selectedData.value + "";
            }
            else if (name === 'ServiceTypeCode') {
                modalEligibility[name] = selectedData.display
                EligibilitySaveUpdate[name] = selectedData.value + "";
            } else if (name === 'PatientInsuranceID') {
                modalEligibility[name] = selectedData.display
                EligibilitySaveUpdate[name] = selectedData.value + "";
            }
        } else if (type === 'server' && !isNull(selectedData)) {
        }
        setmainEligibilityModal(modalEligibility)
        return selectedData
    }
    const EligibilityValidation = async () => {
        let ValidationModal = {
            PatientInsuranceIDval: FormValidator(
                mainEligibilityModal.PatientInsuranceID,
                enumUtil.enumValidationType.Required,
                'Insurance Name',
            ),
        }
        await setEligibilityValidationModal(ValidationModal)
        ValModalEligibility = ValidationModal
    }
    ////////////Error Popup ////////////////
    const handleErrorPopup = (row) => {
        setErrorPopup(<HandleValidationError screenName={row.screenName} fieldName={row.fieldName} setErrorPopup={setErrorPopup} row={row} handlePerformReloadFunction={handleSaveEligibility} />)
    }
    const getIconClass = (Status, isSelected) => {
        // console.log(Status, isSelected);
        // let  isSelected = activeTab === item.PatientInsuranceID
        if (Status && isSelected) {
            return "";
        } else if (Status && !isSelected) {
            return "opacity-40";
        } else if (Status === false && isSelected) {
            return "red";
        } else if (Status === false && isSelected === false) {
            return "red opacity-40";
        } else {
            return "blue opacity-40";
        }
    };


    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainEligibilityModal };
        let saveModal = { ...EligibilitySaveUpdate }
        modal[type] = FormatedDate
        setmainEligibilityModal(modal)
        for (var property in Eligibility_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setEligibilitySaveUpdate(saveModal)
    }
    let dispatch = useDispatch();

    useEffect(() => {
        if (PateintIDR !== -1) {
            if (DropDowns.DiscardIndicator) {
                dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
            }
        }
    }, [DropDowns.DiscardIndicator])
    return (
        <>
            {errorPopup}
            {PopupInsuranceScreen}
            {PopupProviderScreen}
            <div className="mb-1">
                <div className='d-flex justify-content-end gap-1'>

                    {/* <button className="btn btn-orange hk-accordian-btn" onClick={() => setEligibilityPopup(true)}> */}
                    <button className="btn btn-orange me-2 rounded px-2" onClick={() => setEligibilityBody(!EligibilityBody)}>
                        Perform Eligibility
                    </button>
                </div>
            </div>
            {EligibilityBody && (
                <div className="hk-eliScreen">
                    <div className="hk-eliScreen__header">
                        <p className="heading fs-14 dark-clr">Perform Eligibility</p>
                        <button className="btn-icon-transparent" onClick={() => { setEligibilityBody(false); setMessage(''); }}>
                            <i className="icon-x-cros fs-20 dark-clr cursor-pointer"></i>
                        </button>
                    </div>
                    <div className="hk-eliScreen__body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className='input form-group'>
                                    <label htmlFor="SubmissionType">Insurance</label>
                                    <SuperSearchList
                                        type="client"
                                        id='PatientInsuranceID'
                                        name='PatientInsuranceID'
                                        searchValue={mainEligibilityModal.PatientInsuranceID}
                                        data={InsuranceListModal}
                                        onChange={handleEligibilityChange}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                        // isReadOnly={isReadOnly}
                                        inputError={EligibilityValidationModal.PatientInsuranceIDval}
                                    />
                                    {EligibilityValidationModal.PatientInsuranceIDval}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='input form-group'>
                                    <label htmlFor="SubmissionType">Service Type Code</label>
                                    <SuperSearchList
                                        type="client"
                                        id='ServiceTypeCode'
                                        name='ServiceTypeCode'
                                        searchValue={mainEligibilityModal.ServiceTypeCode}
                                        data={ServiceTypeCode}
                                        onChange={handleEligibilityChange}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        sup_btn='sup_btn-Inp'
                                        sup_inp='superSearchVisitInp'
                                    // isReadOnly={isReadOnly}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='input form-group'>
                                    <label htmlFor="SubmissionType">Provider</label>
                                    <div className='form-group input'>
                                        <SuperSearchList
                                            type="client"
                                            id='ProviderID'
                                            name='ProviderID'
                                            searchValue={mainEligibilityModal.ProviderID}
                                            data={DropDowns.Provider}
                                            onChange={handleEligibilityChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        // isReadOnly={isReadOnly}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='input form-group'>
                                    <label htmlFor="EligiblityDate">Eligibility For</label>
                                    <div className='form-group input'>
                                        <DatePicker
                                            id="EligiblityDate"
                                            value={mainEligibilityModal.EligiblityDate}
                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'EligiblityDate')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div class="form-check custom_check_box   form-check-inline">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        name="UsePracticeNPI"
                                        id="UsePracticeNPI"
                                        checked={mainEligibilityModal.UsePracticeNPI}
                                        onChange={handleEligibilityChange}
                                    />
                                    <label class="form-check-label" for="inlineCheckbox2">Use Practice NPI</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="heading ms-4" style={{ color: 'red' }}>{message} &nbsp;
                        {performClaimStatusData?.results?.[0]?.validationMsg && <a className='link-btn' onClick={() => handleErrorPopup(performClaimStatusData.results[0])}>Click Here</a>}
                    </p>

                    {/* <div className="hk-eliScreen__footer">
                        <button className="btn btn-orange hk-accordian-btn" onClick={handleSaveEligibility}>
                            Perform Eligibility
                        </button>
                    </div> */}

                    <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                        <button className={IsEditAllowed ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} onClick={handleSaveEligibility}> Perform Eligibility</button>
                    </div>
                </div>
            )}
            <div className="tabs-container ">
                <div className="app-vertical-tabs create_plan row m-0">
                    <div className="col-md-2 p-0 tabs-menu">
                        <div className='py-3 text-center'>
                        </div>
                        <Nav variant="tabs">
                            {InsuranceListModal && InsuranceListModal.map((item) => {
                                return (
                                    <React.Fragment key={item.PatientInsuranceID}>
                                        <NavItem onClick={() => handleActivePlan(item.PatientInsuranceID)}  >
                                            <NavLink href='#' className={activeTab === item.PatientInsuranceID ? "active" : ""}>
                                                <div className='tab-img' >
                                                    <span className={`icon-insurance-patient fs-60 ${getIconClass(item.STATUS, activeTab === item.PatientInsuranceID)}`}>
                                                        <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                                    <div className={item.CoveragePriority === "P" ?
                                                        "hk-status p" : item.CoveragePriority === "S" ?
                                                            "hk-status s" : item.CoveragePriority === "T" ?
                                                                "hk-status T" : item.CoveragePriority === "O" ?
                                                                    "hk-status O" : ''}>
                                                        {item.CoveragePriority === "P" ? "P" : item.CoveragePriority === "S" ? "S" : item.CoveragePriority === "T" ? "T" : item.CoveragePriority === "O" ? "O" : ''}
                                                    </div>
                                                </div>
                                                {item.ShortName}
                                            </NavLink>
                                        </NavItem>
                                    </React.Fragment>
                                )
                            })}
                        </Nav>
                    </div>
                    <div className="col-md-10 position-relative p-0">
                        {isLoading ? <Loader /> : null}
                        {PopupScreen}
                        {show === false ?
                            <Table
                                columns={columns}
                                rows={EligibilityData}
                                height='450px'
                                rowClass={rowClass}
                                // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                dynamicClass='fill-grid DataGrid-Table hk-exp-table eligibility_table'
                                rowHeight={25}
                                PerPage={PerPage}
                                PageNo={PageNo}
                                TotalPages={TotalPages}
                                handlePageClick={handlePageClick}
                                PreviousPage={PreviousPage}
                                handleFingByCreteria={handleFingByCreteria}
                                NextPage={NextPage}
                                Key={2133}
                                Name={'Eligibility'}
                                hideColClass={'hide'}
                            /> : null
                        }
                    </div>
                </div>
            </div>

        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(Eligibility)